import { ReactElement } from 'react'

import { Column } from '@syconium/little-miss-figgy'

import { ProductGroupTileSkeleton } from './ProductGroupTileSkeleton'

export const CollectionGridSectionTilesSkeleton = ({
  desktopColumns = 12,
}: {
  desktopColumns?: number
}): ReactElement => {
  return (
    <Column
      desktop={desktopColumns}
      hasGutter={false}
      style={{ display: 'flex', flexWrap: 'wrap' }}
    >
      {Array(4 * 4)
        .fill(0)
        .map((_, i) => (
          <Column key={i} desktop={3} mobile={6}>
            <ProductGroupTileSkeleton />
          </Column>
        ))}
    </Column>
  )
}
